module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921102649_T.c4d27efe.jpg";